/* eslint-disable */
import { playgroundAction } from ".";
import {navigate} from "gatsby";

export function loadMySignedId() {
  return async (_, __, { zeusAPI }) => {
    let result = await zeusAPI.playgrounds.getMySignedId();
    return result;
  };
}

export function loadProducts() {
  return async (dispatch, _, { zeusAPI }) => {
    const result = await zeusAPI.playgrounds.getProducts();
    await dispatch(playgroundAction.setProducts(result.data));
    return result;
  };
}

export function loadStandings() {
  return async (dispatch, _, { zeusAPI }) => {
    const result = await zeusAPI.playgrounds.getStandings();
    await dispatch(playgroundAction.setStandings(result.data));
    return result;
  };
}

export function loadMyProfile() {
  return async (dispatch, _, { zeusAPI, toast }) => {
    try {
      const result = await zeusAPI.playgrounds.getMyProfile();
      await dispatch(playgroundAction.setPlayProfile(result.data));
      await dispatch(playgroundAction.hasPlayProfile());
      return result;
    } catch (e) {
      if (parseInt(e.response.status, 10) === 404) {
        navigate("/welcome");
      } else {
        throw e;
      }
    }
  };
}

export function loadMissions() {
  return async (dispatch, _, { zeusAPI }) => {
    try {
    const result = await zeusAPI.playgrounds.getMissions();
    dispatch(playgroundAction.setMissions(result.data));
    return result;
    } catch(e) {
      
    }
  };
}

export function loadMutations(offset = 0, limit = 10) {
  return async (dispatch, _, { zeusAPI }) => {
    const timer = new Promise(r => setTimeout(r, 500));
    const result = await zeusAPI.playgrounds.getInOut(offset, limit);
    await timer;
    dispatch(playgroundAction.setMutations(result.data));
    return result;
  };
}

export function claimBonus() {
  return async (dispatch, _, { zeusAPI }) => {
    const result = await zeusAPI.playgrounds.postClaimBonus();
    await dispatch(playgroundAction.setPlayProfile(result.data));
  };
}

export function loadProduct(productId) {
  return async (dispatch, __, { zeusAPI }) => {
    const result = await zeusAPI.playgrounds.getProduct(productId);
    await dispatch(playgroundAction.setProducts(result.data));
    return result;
  }
}
